import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';
import React, { useState } from 'react';

interface CreateProactiveItemCategoryDialogProps {
	open: boolean;
	onClose: () => void;
	onCreate: (categoryName: string) => void;
}

const CreateProactiveItemCategoryDialog: React.FC<CreateProactiveItemCategoryDialogProps> = ({
	open,
	onClose,
	onCreate,
}) => {
	const [categoryName, setCategoryName] = useState('');

	const handleCreate = () => {
		onCreate(categoryName);
		setCategoryName('');
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Create New Category</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					margin="dense"
					label="Category Name"
					type="text"
					fullWidth
					value={categoryName}
					onChange={(e) => setCategoryName(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="primary">
					Cancel
				</Button>
				<Button onClick={handleCreate} color="primary">
					Create
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CreateProactiveItemCategoryDialog;
